import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import { FaCashRegister, FaClock } from 'react-icons/fa';
import ShiftPage from '../Shifts/ShiftPage';
import ShiftDetails from '../Shifts/ShiftDetails';

const ShiftModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'shifts',
    title: t('modules.shifts.title'),
    description: t('modules.shifts.description'),
    icon: FaClock,
    color: '#198754',
    menuItems: [
      {
        path: '/shifts-module',
        icon: FaClock,
        label: t('nav.shifts')
      },
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/shifts-module/shifts" replace />}  />
        <Route path="/shifts" element={<ShiftPage />} />
        <Route path="/shifts/details" element={<ShiftDetails />} />
      </Routes>
    </ModuleLayout>
  );
};

export default ShiftModule;
